module.exports = __webpack_public_path__ + "img/RCloudDRBD.02d8c6dc.png";